import { IonItem, IonLabel, IonNavLink } from "@ionic/react";
import L10n from "localization";
import { useEffect, useRef, useState } from "react";
import { IPromptOption } from "./singleSelectNav";

interface IProps {
  onNav: (opt: IPromptOption) => React.ReactElement;
  icon?: React.ReactElement;
  prompt: string;
}
export default function OtherListNavItem(props: IProps) {
  const navLinkRef = useRef<HTMLIonNavLinkElement>(null);
  const [navOption, setNavOption] = useState<IPromptOption | null>(null);

  function handleClick() {
    const result = window.prompt(props.prompt, "");
    if (result && result.trim() !== "") {
      const val = result.trim();
      const opt = { name: "other", val };
      setNavOption(opt);
    }
  }

  // Trigger navigation when navOption is set
  useEffect(() => {
    if (navOption) {
      navLinkRef.current?.click();
    }
  }, [navOption]);

  return (
    <>
      <IonItem button onClick={handleClick} lines="none">
        {props.icon ? <div slot="start">{props.icon}</div> : undefined}
        <IonLabel>{L10n.localize((s) => s.general.other)}</IonLabel>
      </IonItem>

      {/* Hidden nav link that gets triggered programmatically */}
      <IonNavLink
        ref={navLinkRef}
        routerDirection="forward"
        component={() => (navOption ? props.onNav(navOption) : null)}
        style={{ display: "none" }}
      />
    </>
  );
}
